import { Section4Mobile } from './Section4Mobile'
import { Section4Desktop } from './Section4Desktop'
import FraserTableDiscussion from '../../../assets/OurStoryImages/fraser-table-discussion.svg'

export const Section4 = () => {
  return (
    <div
      className='w-full h-[850px] md:h-[1056px] lg:h-[1100px] 3xl:h-[1220px] bg-center bg-cover bg-no-repeat'
      style={{ backgroundImage: `url('${FraserTableDiscussion}')` }}
    >
      <div className='hidden md:block'>
        <Section4Desktop />
      </div>
      <div className='block md:hidden'>
        <Section4Mobile />
      </div>
    </div>
  )
}
